
import * as React from "react";
import * as d3 from "d3";


interface IDonutChartProps {
    width: number;
    height: number;
    margin: number;
    innnerRadius: number;
    data: { [key: string]: number } | any;
    containerClassName: string;
    colorScheme?: string[];
    index?: number
}

export class DonutChart extends React.Component<IDonutChartProps, undefined> {
    constructor(props: IDonutChartProps) {
        super(props);
    }

    validateData(data: Array<any>, keys: Array<string>) {

    }


    renderDonutChart(width: number, height: number, margin: number, innnerRadius: number, data: { [key: string]: number } | any, containerClassName: string, colorScheme: string[]) {
        // The radius of the pieplot is half the width or half the height (smallest one). I subtract a bit of margin.
        var radius = Math.min(width, height) / 2 - margin
        let { getColorForIndex, props: { index } } = this;

        // append the svg object to the div called 'my_dataviz'
        var svg = d3.select(`.${containerClassName}`)
            .append("svg")
            .attr("width", width)
            .attr("height", height)
            .append("g")
            .attr("transform", "translate(" + width / 2 + "," + height / 2 + ")");

        // Create dummy data

        // set the color scale
        var color = d3.scaleOrdinal()
            .domain(data)
            .range(colorScheme)

        // Compute the position of each group on the pie:
        var pie = d3.pie()
            // @ts-ignore
            .value(function (d) { return d.value; })
        // @ts-ignore
        var data_ready = pie(d3.entries(data))

        // Build the pie chart: Basically, each part of the pie is a path that we build using the arc function.
        svg
            .selectAll('whatever')
            .data(data_ready)
            .enter()
            .append('path')
            // @ts-ignore
            .attr('d', d3.arc()
                .innerRadius(innnerRadius)         // This is the size of the donut hole
                .outerRadius(radius)
            )
            // @ts-ignore
            .attr('fill', function (d) {
                if ((d.data as any).key === "complete" && (d.data as any).value === 0) {
                    return getColorForIndex(index, "incomplete");
                } else if ((d.data as any).key === "complete" && (d.data as any).value !== 0) {
                    return getColorForIndex(index, "complete");
                } else if ((d.data as any).key === "incomplete") {
                    return getColorForIndex(index, "incomplete");
                }
                return (color(d.data.key))
            })
        // .attr("stroke", "black")
        // .style("stroke-width", "2px")
        // .style("opacity", 0.7)
        // .style("stroke", "#ffffff")
    };

    private getColorForIndex(index: number, key: "complete" | "incomplete"): string {
        if (index === 0) {
            if (key === "complete") {
                return "rgb(220, 171, 242)";
            }
            return "rgb(220, 171, 242, 0.2)"
        } else if (index === 1) {
            if (key === "complete") {
                return "rgb(171, 220, 242)";
            }
            return "rgb(171, 220, 242, 0.2)"
        } else if (index === 2) {
            if (key === "complete") {
                return "rgb(178, 171, 242)";
            }
            return "rgb(178, 171, 242, 0.2)"
        } else {
            if (key === "complete") {
                return "rgb(173, 215, 163)";
            }
            return "rgb(173, 215, 163, 0.2)"
        }
    }



    componentDidMount() {
        const { width, height, margin, innnerRadius, data, containerClassName, colorScheme } = this.props;
        const defaultColorScheme: string[] = ["#98abc5", "#8a89a6", "#7b6888", "#6b486b", "#a05d56"]
        this.renderDonutChart(width, height, margin, innnerRadius, data, containerClassName, colorScheme || defaultColorScheme);
    }

    render() {
        const { containerClassName } = this.props;
        return (
            <div>
                <div className={containerClassName}></div>
            </div>
        )
    }
}


